/* 自動生成ファイル: scripts/build-theme-assets.js が assets/ から作成。直接編集しないこと。 */
/* ============================================================
   スロパチパーツナビ — LINE 相談導線
   ============================================================
   ★★★ LINE 公式アカウント未取得：プレースホルダで動作中 ★★★

   本番化の手順：
     1. LINE Official Account Manager でアカウントを開設
     2. 「ベーシック ID」または「カスタム ID」を取得
        例：@suropachi-parts-navi
     3. 友だち追加 URL（lin.ee 短縮）も発行可能
        例：https://lin.ee/AbCdEfG
     4. 下の CONFIG.officialAccountId を実 ID に書き換える
        （任意で friendAddShortUrl も設定）
     5. 全ページの LINE ボタンが自動的に本番 URL に切り替わる

   このファイル 1 つに LINE 関連の動作・文言・URL 生成が集約されています。
   HTML 側は data-line="..." 属性を置くだけ。
   ============================================================ */

(function () {
  "use strict";

  // ============================================================
  // 1. CONFIG — ★★★ ここを編集すれば全ページに反映 ★★★
  // ============================================================
  const CONFIG = {
    // LINE 公式アカウント ID（@ から始める）
    // 例：officialAccountId: "@suropachi-parts-navi"
    officialAccountId: "@819bsyxv",

    // 友だち追加用の短縮 URL（lin.ee）— 取得したら設定
    // null の場合は officialAccountId から自動組み立て
    friendAddShortUrl: null,

    // 営業時間（FAQ・誘導文言・自動応答案内に使用）
    businessHours: "平日 10:00–17:00",
    businessHoursShort: "平日 10–17 時",

    // FAB のラベル
    fabLabel: "LINEで相談",

    // FAB の自動注入を停止したいページは body に no-line-fab クラスを付ける
    fabBodyExclusionClass: "no-line-fab",

    // メッセージテンプレート（pre-fill）
    // {var} は data-* 属性から差し込み
    templates: {
      product:       "[商品: {code} / {name}]\nこの商品について質問させてください。\n（機種：　　　　　　　　／ お困りの内容：　　　　　　　　）",
      category:      "[カテゴリ: {name}]\nこのカテゴリの商品について質問させてください。\n（お持ちの機種：　　　　　　　　）",
      "search-empty":"[検索ゼロ件: {query}]\nお探しの機種について教えてください。\n（機種名・型番：　　　　　　　　）",
      // 検索結果はあるが選びきれない場合（2026-10-14 追加: 結果があるのに「ゼロ件」と送られていたため）
      search:        "[機種検索: {query}]\nお持ちの機種に合うユニットについて相談させてください。\n（機種名・型番：　　　　　　　　）",
      // 機種ページ「この機種について LINE で確認」（2026-10-14 追加: カテゴリ用の文面が流用されていたため）
      machine:       "[機種: {machine-name}]\nこの機種に合うユニットについて相談させてください。\n（お困りの内容：　　　　　　　　）",
      // ドアキー・設定キー（2026-11-03 追加）
      key:           "[鍵の相談]\nお持ちの機種のドアキー・設定キーについて教えてください。\n（機種名：　　　　　　　　／ 鍵穴まわりの刻印：　　　　　　　　）",
      guide:         "[ガイド経由]\n質問させてください。",
      free:          "",
      fab:           "",
    },
  };

  // ============================================================
  // 2. URL ビルダー
  // ============================================================
  // メッセージ事前入力（oaMessage）はスマホの LINE アプリ専用。PC で開くと LINE のトップページへ
  // 転送されてしまうため（2026-10-14 確認）、PC では友だち追加ページ（QR コード表示）に切り替える
  const IS_MOBILE = /iPhone|iPad|iPod|Android|Mobile/i.test(navigator.userAgent || "");

  function buildUrl(message) {
    const id = encodeURIComponent(CONFIG.officialAccountId);
    if (!message || !IS_MOBILE) {
      // 友だち追加 URL（短縮があればそちらを優先）
      return CONFIG.friendAddShortUrl || ("https://line.me/R/ti/p/" + id);
    }
    // メッセージ事前入力 URL
    return "https://line.me/R/oaMessage/" + id + "/?" + encodeURIComponent(message);
  }

  function fillTemplate(template, attrs) {
    return template.replace(/\{(\w[\w-]*)\}/g, function (_, key) {
      // data-product-code → attrs.product-code, data-name → attrs.name
      return attrs[key] != null ? attrs[key] : "";
    });
  }

  function urlFromElement(el) {
    const type = el.getAttribute("data-line") || "free";
    const tpl = CONFIG.templates[type];
    if (tpl == null) return buildUrl();

    // data-* 属性をすべて吸い上げ（data-product-code → "product-code" / "code"）
    const attrs = {};
    Array.from(el.attributes).forEach(function (a) {
      if (a.name.indexOf("data-") === 0 && a.name !== "data-line") {
        const key = a.name.slice(5); // "product-code"
        attrs[key] = a.value;
        // よく使う短縮キー
        if (key === "product-code") attrs.code = a.value;
        if (key === "product-name") attrs.name = a.value;
        if (key === "category-name") attrs.name = a.value;
        if (key === "search-query")  attrs.query = a.value;
      }
    });

    const message = fillTemplate(tpl, attrs);
    return buildUrl(message);
  }

  // ============================================================
  // 3. data-line 属性をすべて URL 化
  // ============================================================
  function bindAllLinks() {
    document.querySelectorAll("[data-line]").forEach(function (el) {
      // <a> 以外の要素も href 風に動かしたい場合のため、まず href があれば設定
      if ("href" in el || el.tagName === "A") {
        el.setAttribute("href", urlFromElement(el));
      } else {
        // <button> の場合はクリックで遷移
        el.addEventListener("click", function () {
          window.open(urlFromElement(el), "_blank", "noopener");
        });
      }
      // すべて新しいタブで開く（LINE アプリ起動 / Web 版どちらでも安全）
      if (el.tagName === "A" && !el.getAttribute("target")) {
        el.setAttribute("target", "_blank");
        el.setAttribute("rel", "noopener");
      }
    });
  }

  // ============================================================
  // 4. フローティング相談ボタン (FAB) を body に自動注入
  // ============================================================
  function injectFab() {
    if (document.body.classList.contains(CONFIG.fabBodyExclusionClass)) return;
    if (document.querySelector(".line-fab")) return; // 重複防止

    const fab = document.createElement("a");
    fab.className = "line-fab";
    fab.setAttribute("data-line", "fab");
    fab.setAttribute("aria-label", CONFIG.fabLabel);
    fab.setAttribute("target", "_blank");
    fab.setAttribute("rel", "noopener");
    fab.href = buildUrl();
    fab.innerHTML =
      '<span class="line-fab-icon">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
          '<path d="M12 2C6.5 2 2 5.7 2 10.2c0 2.7 1.6 5.1 4.1 6.6l-.5 2c-.1.4.3.7.6.5 0 0 2.6-1.6 3.4-2.1.8.1 1.5.2 2.4.2 5.5 0 10-3.7 10-8.2S17.5 2 12 2zm-3.6 10.7H6.5c-.2 0-.4-.2-.4-.4V8.5c0-.2.2-.4.4-.4s.4.2.4.4v3.4h1.5c.2 0 .4.2.4.4s-.2.4-.4.4zm1.7-.4c0 .2-.2.4-.4.4s-.4-.2-.4-.4V8.5c0-.2.2-.4.4-.4s.4.2.4.4v3.8zm5.2 0c0 .2-.1.3-.3.4-.1 0-.1 0-.1 0-.1 0-.2 0-.3-.2L13 9.9v2.4c0 .2-.2.4-.4.4s-.4-.2-.4-.4V8.5c0-.2.1-.3.3-.4.1 0 .1 0 .1 0 .1 0 .2 0 .3.2L14.5 11V8.5c0-.2.2-.4.4-.4s.4.2.4.4v3.8zm3-2.3c.2 0 .4.2.4.4s-.2.4-.4.4h-1.5v.9h1.5c.2 0 .4.2.4.4s-.2.4-.4.4h-1.9c-.2 0-.4-.2-.4-.4V8.5c0-.2.2-.4.4-.4h1.9c.2 0 .4.2.4.4s-.2.4-.4.4h-1.5v.9h1.5z"/>' +
        '</svg>' +
      '</span>' +
      '<span class="line-fab-label">' + CONFIG.fabLabel + '</span>';
    (document.querySelector("[data-spn-fab-host]") || document.body).appendChild(fab);
  }

  // ============================================================
  // 5. プレースホルダ警告（本番化忘れ防止）
  // ============================================================
  function warnIfPlaceholder() {
    if (CONFIG.officialAccountId.indexOf("@TODO") === 0) {
      try {
        console.warn(
          "%c[LINE] 公式アカウント ID が未設定です。",
          "background: #FFE066; color: #663C00; font-weight: bold; padding: 2px 6px;",
          "\nassets/line.js の CONFIG.officialAccountId を更新してください。"
        );
      } catch (e) { /* no-op */ }
    }
  }

  // ============================================================
  // 6. 初期化
  // ============================================================
  function init() {
    bindAllLinks();
    injectFab();
    warnIfPlaceholder();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // デバッグ用
  window.LINE = {
    config: CONFIG,
    url: buildUrl,
    urlForElement: urlFromElement,
    rebind: bindAllLinks,
  };
})();
